import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ExcelCommandDirective } from '@progress/kendo-angular-grid';
import { IfExportAllowedDirective } from '@ups/xplat/web/core';

/**
 * Kendo grid "Export to Excel" toolbar button, shown only to users allowed to export
 * (#34476). Place it inside a `kendoGridToolbarTemplate`; the enclosing grid's
 * `<kendo-grid-excel>` still configures the export.
 */
@Component({
  selector: 'ups-grid-excel-button',
  templateUrl: './grid-excel-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ExcelCommandDirective, IfExportAllowedDirective],
})
export class GridExcelButtonComponent {
  readonly text = input('Export to Excel');
}
